<template>
    <div class="main-page-wrap">
        <div v-if="questions && questions.length && questionsGroups.length">
            <form class="respondents-group mt-4" @submit.prevent="onNextGroup">
                <div class="respondents-group__title mb-4">{{groupIndex + 1}}. {{group.title}}</div>

                <div v-for="(id, index) in group.questions" :key="`${groupIndex}_${index}`">
                    <div v-if="isObject(id)">
                        <table-events-effect v-if="id.num === 313" :ids="id.questions" @sendAnswer="saveTableAnswer"/>
                        <table-events v-else-if="id.num === 61" :ids="id.questions" @sendAnswer="saveTableAnswer"/>
                        <table-skills v-else-if="id.num === 65" :ids="id.questions" @sendAnswer="saveTableAnswer"/>
                        <table-quality v-else-if="id.num === 71" :ids="id.questions" @sendAnswer="saveTableAnswer"/>
                        <table-documents v-else-if="id.num === 73" :ids="id.questions" @sendAnswer="saveTableAnswer"/>
                        <table-progress v-else-if="id.num === 75" :ids="id.questions" @sendAnswer="saveTableAnswer"/>
                        <table-skills-input v-else-if="id.num === 76" :ids="id.questions" @sendAnswer="saveTableAnswer"/>
                    </div>
                    <question-item :id="id" v-else-if="items[id]" v-model="items[id].value"></question-item>
                </div>

                <div class="text-xs-center">
                    <v-btn color="success" type="submit" :loading="pending">Продолжить</v-btn>
                </div>
            </form>
        </div>
        <div class="text-xs-center" v-else>
            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </div>
        <br>
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex'
    import gorups from '@/mocks/respondents.json'
    import QuestionItem from './question.vue'
    import VueScrollTo from 'vue-scrollto'
    import TableEventsEffect from './table313'
    import TableEvents from './table61'
    import TableSkills from './table65'
    import TableQuality from './table71'
    import TableDocuments from './table73'
    import TableProgress from './table75'
    import TableSkillsInput from './table76'

    export default {
        components: {
            QuestionItem,
            TableEvents,
            TableQuality,
            TableSkills,
            TableProgress,
            TableDocuments,
            TableSkillsInput,
            TableEventsEffect
        },
        data () {
            return {
                pending: false,
                groupIndex: 0,
                type: '',
                items: []
            }
        },
        props: {
            options: Object
        },
        computed: {
            ...mapGetters('questions', ['question', 'questions']),
            ...mapState('auth', ['role']),

            questionsGroups () {
                return gorups[this.role]
            },
            group () {
                return this.questionsGroups[this.groupIndex]
            },
            groupIds () {
                let result = []

                this.group.questions.forEach(item => {
                    if (this.isObject(item)) {
                        result = result.concat(item.questions)
                    } else {
                        result.push(item)
                    }
                })

                return result
            },
            sendData () {
                let result = []
                for (let id in this.groupIds) {
                    let value = this.groupIds[id]

                    result.push({
                        quest: value,
                        text: this.items[value].value
                    })
                }
                return result
            }
        },
        mounted () {
            this.$store.dispatch('questions/init', {
                stage: this.options.stage
            }).then(() => {
                if (!this.questions.length) {
                    this.$store.dispatch('questions/next')
                } else if (!this.questionsGroups.length) {
                    this.$store.dispatch('questions/skip')
                }
            })
        },
        methods: {
            saveTableAnswer (value, id) {
                this.items[id].value = value
            },
            isObject (v) {
                return (typeof v).toLowerCase() === 'object'
            },
            onNextGroup () {
                if (this.pending) return
                this.pending = true

                let groupIndex = this.groupIndex + 1

                this.$store.dispatch('questions/answers', this.sendData)
                    .then(() => {
                        this.pending = false
                        if (groupIndex >= this.questionsGroups.length) {
                            this.$store.dispatch('testing/next')
                            this.$store.dispatch('questions/reset')
                        } else {
                            VueScrollTo.scrollTo(document.querySelector('body'), 1500)
                            this.groupIndex = groupIndex
                        }
                    })
                    .catch(() => (this.pending = false))
            },
            getValue (question) {
                if (question.type === 'checkbox') {
                    return []
                } else {
                    return ''
                }
            }
        },
        watch: {
            questions (questions) {
                let items = {}
                questions.forEach(item => {
                    items[item.id] = {
                        id: item.id,
                        value: this.getValue(item)
                    }
                })
                this.items = items
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .respondents {
        &-group {
            &__title {
                font-size 20px
                font-weight bold
            }
        }
    }
</style>
